import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getActiveCompany, getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'

export const apiTemplateSettingsGET = async (): Promise<Array<any>> => {
  const company = getActiveCompany()?.id
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    // `https://localhost:59923/FetchTemplateConfiguration?company=${company}`
    `${apiSuffixUrl}/FetchTemplateConfiguration?company=${company}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}
export const apiProductsGET = async (): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.get(`${apiSuffixUrl}/FetchTemplateProducts`).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}
export const apiContractTypeGET = async (): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.get(`${apiSuffixUrl}/FetchContractType`).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}
export const apiClientGET = async (): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.get(`${apiSuffixUrl}/FetchClients`).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiTemplateIdGET = async (registerId: number): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.get(
    // `https://localhost:59923/FetchTemplateId?registerId=${registerId}`
    `${apiSuffixUrl}/FetchTemplateId?registerId=${registerId}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiTemplateSettingsUpdate = async (templateSettings: any): Promise<boolean> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.post(
    //`https://localhost:63910/UpdateTemplate`,
    `${apiSuffixUrl}/UpdateTemplate`,
    templateSettings
  ).then(res => {
    return true
  })
}

export const apiTemplateSettingsCreate = async (templateSettings: any): Promise<boolean> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.post(
    //`https://localhost:63910/CreateTemplate`,
    `${apiSuffixUrl}/CreateTemplate`,
    templateSettings
  ).then(res => {
    return true
  })
}

export const apiFetchTemplatesByProductId = async (id: number): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    // `https://localhost:59923/FetchTemplatesByProductId?productId=${id}`
    `${apiSuffixUrl}/FetchTemplatesByProductId?productId=${id}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiUpdateListadoConceptosByProductId = async (productId: number): Promise<boolean> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.post(
    //`https://localhost:63910/UpdateListadoConceptosByProductId?productId=${productId}`
    `${apiSuffixUrl}/UpdateListadoConceptosByProductId?productId=${productId}`
  ).then(res => {
    return true
  })
}
